import React from "react";
import { Redirect } from "react-router-dom";
import * as paths from "routes/paths";

// MAX-4419: /settings/css is retired. Its custom code fields are now sections of the Display page,
// so old bookmarks and help links land there.
export const SettingsDisplayRedirect: React.FC = () => (
	<Redirect to={paths.settingsDisplay} />
);
